module.exports = __webpack_public_path__ + "img/login-head.33f48d08.png";